import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { UpdateTimer, QueueAction, GetGateTimes } from '../../../store/actions/gateActions'; 
import { TimePicker, Switch, Menu, Row, Col, Divider, Layout, Button, Modal } from 'antd';
import 'antd/dist/antd.css';
import TextField from '@material-ui/core/TextField';
import { Zoom } from '@material-ui/core';
import moment from 'moment';

const { Content, Sider } = Layout;
const { RangePicker } = TimePicker;

function GateSchedule(props) {

    const { gate, privates } = props;

    const [timerTab, setTimerTab] = useState("0");
    const [timeData, setTimeData] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const gate_id = window.location.pathname.split("/")[3];

    useEffect(() => {
        if( isLoading ) {
            if( props.times.length === 0 ) { 
                //Get Time Data if Loading and No Times has been loaded
                props.GetGateTimes(gate_id);
            } else if( timeData !== props.times && props.times.length > 0 ) { 
                //Set State of Loaded Time Data
                setTimeData(props.times);
                setLoading(false);
            }
        }
    },[props.times]);

    const handleTabChange = (key) => {
        if( key === "sync" ) return;
        setTimerTab(10);
        setTimeout(() => {
            setTimerTab(key)
        },100);
    };

    const updateTimers = () => {
        props.QueueAction(gate_id, "update_timers");
    }
    const handleTimeChange = (schedule, day, i, times) => {
        let data = timeData;
        data[schedule][day.toLowerCase()][i]["from"]    = times[0].format("HHmm");
        data[schedule][day.toLowerCase()][i]["to"]      = times[1].format("HHmm");
        setTimeData([...data]);
        props.UpdateTimer(gate_id, i, data[i]);
    }
    const setScheduleActive = (i, value) => {
        let data = timeData;
        data[i].active = value;
        setTimeData([...data]);
        props.UpdateTimer(gate_id, i, data[i]);
    }
    const setTimeActive = (schedule, day, i, value) => {
        let data = timeData;
        data[schedule][day.toLowerCase()][i]["active"] = value;
        setTimeData([...data]);
        props.UpdateTimer(gate_id, i, data[i]);
    }
    const updateTitle = (i, title) => {
        let data = timeData;
        data[i].name = title;
        setTimeData([...data]);
        props.UpdateTimer(gate_id, i, data[i]);
    }

    if( isLoading ) {
        return (
            <div className="container gateDetail">
                <div className="row" style={{ marginBottom: "0" }}>
                    <div className="col s6">
                        <div className="col s12">
                            Loading...
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    let weekdays = ["Mon",  "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    return (
        <div className="col s6">
            <Layout className="site-layout-background">
                <Sider className="site-layout-background" width={200}>
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={[timerTab]}
                        defaultOpenKeys={['sub1']}
                        style={{ height: '100%' }}
                        onClick={(e) => handleTabChange(e.key) }
                    >
                        {timeData.map((time,i) => {
                            if( i === 6 ) return <Menu.Item key={i}>Auto Open/Close Timer</Menu.Item>
                            return <Menu.Item key={i} title={time.name}>{time.name}</Menu.Item>
                        })}
                        <Menu.Item id={"syncTimeButton"} disabled key={"sync"}>
                            <Button type="primary" onClick={updateTimers} loading={privates.queued_actions.includes("update_timers")}>Sync Timers</Button>
                        </Menu.Item>
                    </Menu>
                </Sider>
                <div style={{minHeight: "837px"}}>
                {timeData.map((time,i) => timerTab === i.toString() &&
                    <Zoom
                        key={i}
                        in={timerTab === i.toString()}
                        style={{ transitionDelay: (timerTab === i.toString()) ? '500ms' : '0ms' }} 
                    >
                        <Content key={i} style={{ padding: '25px', minHeight: 280, background: "#fff" }}>
                            {i !== 6 && <TextField fullWidth variant="outlined" onChange={(e) => updateTitle(i, e.target.value)} defaultValue={time.name} name="name" label="Time Name" />}
                            <Row>
                                { weekdays.map(day => 
                                    <Col span={12} key={day} className="time" style={{padding: "15px"}}>
                                        <div className="day">{day}</div>
                                        <div className="input">
                                            <RangePicker use12Hours minuteStep={5} format="h:mm a" 
                                                defaultValue={[
                                                    moment().hour(time[day.toLowerCase()][0].from.substr(0,2)).minute(time[day.toLowerCase()][0].from.substr(2,2)),
                                                    moment().hour(time[day.toLowerCase()][0].to.substr(0,2)).minute(time[day.toLowerCase()][0].to.substr(2,2))
                                                ]}
                                                onChange={(times) => handleTimeChange(i,day,0,times)}
                                            />
                                            <Switch defaultChecked={time[day.toLowerCase()][0].active} onChange={(value) => setTimeActive(i, day, 0, value)} />
                                        </div>
                                        <div className="input">
                                            <RangePicker use12Hours minuteStep={5} format="h:mm a" 
                                                defaultValue={[
                                                    moment().hour(time[day.toLowerCase()][1].from.substr(0,2)).minute(time[day.toLowerCase()][0].from.substr(2,2)),
                                                    moment().hour(time[day.toLowerCase()][1].to.substr(0,2)).minute(time[day.toLowerCase()][0].to.substr(2,2))
                                                ]}
                                                onChange={(times) => handleTimeChange(i,day,1,times)}
                                            />
                                            <Switch defaultChecked={time[day.toLowerCase()][1].active} onChange={(value) => setTimeActive(i, day, 1, value)} />
                                        </div>
                                    </Col>
                                ) }
                            </Row>
                            <Divider />
                            <div className="input">
                                <span style={{marginRight: "15px"}}>Enable this Timer</span>
                                <Switch defaultChecked={time.active} onChange={(value) => setScheduleActive(i, value)} />
                            </div>
                        </Content>
                    </Zoom>
                )}
                </div>
            </Layout>
        </div>
    );

}

const mapStateToProps = (state) => {
    return {
        gate:       state.gate.gate,
        times:      state.gate.times,
        privates:   state.gate.privates
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        UpdateTimer:   (gate_id, i, time_data) => dispatch(UpdateTimer(gate_id, i, time_data)),
        QueueAction:   (gate_id, action)       => dispatch(QueueAction(gate_id, action)),
        GetGateTimes:  (gate_id)               => dispatch(GetGateTimes(gate_id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GateSchedule);
